import React, { useState, useEffect } from "react";
import { useFetchQCPlatelist } from "../Hooks/QC/useFetchQCPlateList";
import { DataGrid, GridToolbar } from "@material-ui/data-grid";
import { Link, useParams } from "react-router-dom";
import useFetchPlateName from "../Hooks/QC/useFetchPlateName";
import RenderButton from "../common/Renderers/RenderButton";
import { Tooltip } from "@material-ui/core";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { plateTypes } from "../constants/plateTypes";
import useFetchSerialNumbers from "../Hooks/Mfg/useFetchSerialNumbers";
import useMutateUndoPlateName from "../Hooks/Mfg/useMutateUndoPlateName";
import DropDownRenderer from "../common/Renderers/DropDownRenderer";
import { Dialog, DialogContent, DialogTitle, IconButton, DialogActions, Button } from '@material-ui/core';
import UndoIcon from "@material-ui/icons/Undo";
import Spinner from "../common/Spinner";
import { formatDate } from "../../utils/basic";

function LinkRenderer(props) {
    const { item } = useParams();
    const { batch_id, plate_uuid, platename, type } = props.row;

    let linkTo;
    if (batch_id && platename && !plate_uuid) {
        linkTo = "/qlpqc/add";
    } else if (batch_id && platename && plate_uuid) {
        linkTo = `/${item}/metrics/${plate_uuid}`;
    } else if (batch_id && !plate_uuid && !platename) {
        linkTo = `/genPlate${type}/${batch_id}`;
    }

    return (
        <Link to={linkTo} style={{ textDecoration: "none", color: "inherit" }}>
            {batch_id}
        </Link>
    );
}

function ButtonRenderer(props) {
    const { item } = useParams();
    const { isLoading, isError, data } = useFetchSerialNumbers(item);
    const [open, setOpen] = useState(false);

    const upperCaseItem = item.toUpperCase();

    const { batch_id, plate_uuid, platename, type } = props.row;
    const { fetchNewPlateNameMutation } = props


    let linkTo, buttonText;
    if (batch_id && platename && !plate_uuid) {
        linkTo = "/qlpqc/add";
        buttonText = "Upload File";
    } else if (batch_id && platename && plate_uuid) {
        linkTo = `/${item}/metrics/${plate_uuid}/${platename}`;
        buttonText = `${upperCaseItem} Metrics`;

    } else if (batch_id && !plate_uuid && !platename) {
        //linkTo = `/genPlate/${type}/${batch_id}`;
        buttonText = "Generate Plate";
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleSelect = (selectedValue) => {
        // Apply selected value to mutation           
        fetchNewPlateNameMutation.mutate({ batch_id, type, item, selectedValue });
        // Close modal after selecting
        handleClose();
    }

    //const uniqueSerialNumbers = [...new Set(data?.data?.map(item => item.serial_number))];
    const handleClick = (e) => {
        // e.preventDefault();
        if (buttonText === "Generate Plate") {
            switch (item) {
                case plateTypes.mfg:
                    setOpen(true);
                    break;
                case plateTypes.qc:
                    fetchNewPlateNameMutation.mutate({ batch_id, type, item });
                    break;
                default:
                    console.log("erro in switch case");
                    break;
            };
        }
    };

    return (
        <>
            {buttonText !== "Generate Plate" &&
                RenderButton(buttonText, handleClick, { component: Link, to: linkTo })
            }

            {buttonText === "Generate Plate" &&
                <div>
                    {RenderButton(buttonText, handleClick)}
                    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                        <DialogTitle className="dialog-title ">Select a Serial Number</DialogTitle>
                        <DialogContent className="dialog-content">
                            <DropDownRenderer options={data} onSelect={handleSelect} handleClose={handleClose} />
                        </DialogContent>
                    </Dialog>
                </div>
            }
        </>
    );


}


function DownloadTemplate(props) {
    const { batch_id, type } = props.row;
    const { mutationResult } = props;
    if (!mutationResult?.signedUrl) {
        return null; // Don't render anything if there's no signedUrl
    }

    return (
        batch_id === mutationResult?.batch_id && type === plateTypes.fluver &&
        <Tooltip title="Download Template">
            <a href={mutationResult?.signedUrl} target="_blank" rel="noopener noreferrer" style={{ color: "#00a650", marginTop: "10px" }}>
                <CloudDownloadIcon fontSize="large" />
            </a>

        </Tooltip>

    );
}



const QCPlatesList = () => {

    const { item } = useParams();
    const upperCaseItem = item.toUpperCase();
    const plateListQuery = useFetchQCPlatelist();
    const listData = plateListQuery?.isSuccess ? plateListQuery?.data?.data : null;

    // Refactor to use useImmer TODO
    const [rows, setRows] = useState([]);
    const [undoOpen, setUndoOpen] = useState(false);
    const [batchIdToUndo, setBatchIdToUndo] = useState();
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        // Define the function to update the rows based on searchQuery
        const updateRows = (data) => {
            if (searchQuery?.length >= 3) {
                const filteredData = data.filter((row) =>
                    row?.platename?.toLowerCase().includes(searchQuery?.toLowerCase())
                );
                setRows(filteredData);
            } else {
                setRows(data); // Reset to original data if query is too short
            }
        }

        if (listData) {
            const initialRowsData = listData.map(item => ({
                "batch_id": item?.batch_id,
                "batch_date": item?.batch_date ? formatDate(item?.batch_date) : "",
                "plate_date": item?.plate_date ? formatDate(item?.plate_date) : "",
                "creator": item?.creator,
                "lot_number": item?.lot_number,
                "plate_uuid": item?.plate_uuid,
                "platename": item?.platename,
                "type": item?.type,
                "id": crypto.randomUUID() // Generate a random ID for each row
            }));

            updateRows(initialRowsData); // Update rows based on the initial data
        }
    }, [listData, searchQuery]); // Depend on both listData and searchQuery



    const fetchNewPlateNameMutation = useFetchPlateName();

    //   const mutationSuccess = fetchNewPlateNameMutation?.isSuccess;
    const mutationResult = fetchNewPlateNameMutation?.data;

    const mutationUndoPlateName = useMutateUndoPlateName();
    const cols = [
        {
            field: 'batch_id',
            headerName: 'Batch Name',
            description: 'Batch Name',
            //renderCell: LinkRenderer,
            width: 320
        },
        {
            field: 'platename',
            headerName: 'Plate Name',
            description: 'Plate Name',
            width: 400,
            renderCell: (params) => {
                if (item == plateTypes?.mfg && params?.row?.batch_id && (params?.row?.platename && !params?.row?.platename?.toUpperCase().startsWith("QC")) && !params?.row?.plate_uuid) {
                    return (
                        <>
                            {params.value}
                            <IconButton
                                onClick={() => {
                                    setBatchIdToUndo(params?.row?.batch_id);
                                    setUndoOpen(true);
                                }}
                            >
                                <UndoIcon />
                            </IconButton>
                        </>
                    );
                } else {
                    return params.value;
                }
            }
        },
        {
            field: "action",
            headerName: "Action",
            width: 200,
            renderCell: (params) => <ButtonRenderer {...params} fetchNewPlateNameMutation={fetchNewPlateNameMutation} />
            // This tells the DataGrid to use ButtonRenderer for rendering the action column cells
        },
        {
            field: "download",
            headerName: "Download",
            width: 200,
            renderCell: (params) => <DownloadTemplate {...params} mutationResult={mutationResult} />
        },

        {
            field: 'type',
            headerName: 'Plate Type',
            description: 'Plate Type',
            width: 200
        },
        {
            field: 'creator',
            headerName: 'Creator',
            description: 'Creator',
            width: 220
        },
        {
            field: 'lot_number',
            headerName: 'Lot #',
            description: 'Lot #',
            //renderCell: LinkRenderer,
            width: 220
        },
        {
            field: 'batch_date',
            headerName: 'Batch Date',
            description: 'Batch Date',
            width: 250
        },
        {
            field: 'plate_date',
            headerName: 'Plate Date',
            description: 'Plate Date',
            width: 250
        },


        {
            field: 'plate_uuid',
            headerName: 'Plate Uid',
            description: 'Plate Uid',
            width: 350
        },



    ];

    return (
        <>
            <div className="flex flex-col gap-y-6 oneToolContainer">
                <h5 className="text-custom-green font-bold text-center">{upperCaseItem} Plates List</h5>

                <div className="">
                    <input
                        type="text"
                        value={searchQuery}
                        placeholder="Search Plate Name..."
                        className="border border-gray rounded-[8px] px-2 py-1 text-sm w-40 focus:outline-none focus:ring-2 focus:ring-custom-green"
                        onChange={(event) => setSearchQuery(event.target.value)}
                    />
                </div>



                {(fetchNewPlateNameMutation?.isLoading || mutationUndoPlateName?.isLoading) &&
                    <div className="backdrop center-child">
                        <Spinner text={fetchNewPlateNameMutation?.isLoading ? "Generating Plate Name.." : mutationUndoPlateName?.isLoading ? "Undo in progress.." : "Loading..."} />
                    </div>
                }

                {rows?.length > 0 ?
                    <div className=" h-[75dvh]">
                        <DataGrid columns={cols} rows={rows} components={{
                            Toolbar: GridToolbar
                        }}
                            componentsProps={{
                                cell: {
                                    fetchNewPlateNameMutation,
                                    mutationResult,

                                },
                            }}>
                        </DataGrid>
                    </div> : <Spinner text="Fetching Data... Pls wait" />}

                <Dialog open={undoOpen} onClose={() => setUndoOpen(false)}>
                    <DialogTitle>Confirm undo</DialogTitle>
                    <DialogContent>
                        Are you sure you want to undo the plate name?
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                mutationUndoPlateName.mutate(batchIdToUndo);
                                setUndoOpen(false);
                            }}
                        >
                            Confirm
                        </Button>
                        <Button onClick={() => setUndoOpen(false)}>Cancel</Button>
                    </DialogActions>
                </Dialog>
            </div>
        </>
    )

}

export default QCPlatesList;
